import { Injectable } from '@angular/core';
import {HttpService} from "jrz-http";
import {Observable} from "rxjs";
import {BASE_URL} from "./base-url.const";

@Injectable({
  providedIn: "root"
})
export class HealthService {

  constructor( private httpService: HttpService ) { }

  public getHealth(): Observable<any> {
    return this.httpService.get(BASE_URL + "/health");
  }
}
